import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=5fd64574&"
import script from "./Documentation.vue?vue&type=script&lang=js&"
export * from "./Documentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports